import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';

class GetHomepageRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Get Homepage Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        if(window.HomePage) {
            this.response = {data: window.HomePage};
            this.onSuccess();
        } else {
            this.call(this.Config.api.requests.getHomepage);
            // this.call(this.Config.api.requests.getHomepage, undefined, 'post', {
            //     basePath: 'http://localhost:8080/content/api/homepage',
            //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            //     stringifyData: true,
            // });
        }
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState(data) {
        this.dispatch(Actions.setHomepageData(data));

    }
}

export default GetHomepageRequest;
